import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import Modal from '../Modal'
import ExtendSuccess from './components/ExtendSuccess/ExtendSuccess'
import Loader from './components/Loader/Loader'
import Content from './components/Content/Content'
import Toast from '../../Toast/Toast'

import './TrialEndedModal.scss'
import { API__USER } from '../../../../api'
import { USER__SET_NOTIFICATIONS, USER__SET_SUBSCRIPTION, USER__SET_TRIAL_COUNT } from '../../../../store/actions'
import { NEW_SUB_TO_TRIAL, OLD_PAID_SUB_TO_TRIAL, OLD_SUB_TO_TRIAL } from '../../../constants/ProductConstants'

export const TrialEndedModal = ({ t, onClose, userTrialCount, notifications, userId }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isExtended, setIsExtended] = useState(false)
    const dispatch = useDispatch()

    const notification = notifications
        ? notifications.find(obj => [OLD_SUB_TO_TRIAL, OLD_PAID_SUB_TO_TRIAL, NEW_SUB_TO_TRIAL].includes(obj.type))
        : null
    const trialType = notification ? notification.type : null

    const updateUserTrial = async () => {
        if (!notifications) {
            dispatch(USER__SET_NOTIFICATIONS(await API__USER.GET_NOTIFICATIONS(userId)))
        }
        await API__USER.RESET_TRIAL(userId)
        dispatch(USER__SET_SUBSCRIPTION(await API__USER.GET_SELECTED_SUBSCRIPTION(userId)))
        dispatch(USER__SET_TRIAL_COUNT(await API__USER.GET_TRIAL_COUNT(userId)))
        if (notification) {
            await API__USER.SET_NOTIFICATION_READ(notification.userId, notification.id)
        }
        dispatch(USER__SET_NOTIFICATIONS(await API__USER.GET_NOTIFICATIONS(userId)))
    }

    const onExtendTrialPeriod = async () => {
        setIsLoading(true)
        try {
            await updateUserTrial()
            setIsExtended(true)
        } catch (err) {
            console.error(err)
            Toast('error', {})
        }
        setIsLoading(false)
    }

    return (
        <Modal onClose={() => onClose()} closeOnOverlayClick={false} isShowCloseIcon={!isLoading}>
            <div className="trial-ended-modal">
                {isLoading ? (
                    <Loader />
                ) : (
                    <>
                        {isExtended ? (
                            <ExtendSuccess onClose={() => onClose()} t={t} />
                        ) : (
                            <Content
                                t={t}
                                userTrialCount={userTrialCount}
                                trialType={trialType}
                                onExtend={() => onExtendTrialPeriod()}
                            />
                        )}
                    </>
                )}
            </div>
        </Modal>
    )
}
